<div class="participantes-entrada">
  <p>Redirigiendo a la zona segura...</p>
</div>
